import I18n from 'I18n';
const getPrimaryAction = props => {
  console.debug(props);
  const onViewPortalClicked = () => {
    console.debug('View clicked');
  };
  return {
    label: I18n.text('flywheel.FlywheelDemoPortalCard.ChickletHoverActions.viewPortal'),
    onClick: onViewPortalClicked
  };
};
const getSecondaryActions = props => {
  console.debug(props);
  const onEditPortalClicked = () => {
    console.debug('Edit clicked');
  };
  return [{
    label: I18n.text('flywheel.FlywheelDemoPortalCard.ChickletHoverActions.editLease'),
    onClick: onEditPortalClicked
  }];
};
export const DemoPortalChickletHoverActions = props => ({
  PrimaryAction: getPrimaryAction(props),
  SecondaryActions: getSecondaryActions(props)
});